import { render } from "./Tichete.vue?vue&type=template&id=7b293ad2&scoped=true&ts=true"
import script from "./Tichete.vue?vue&type=script&lang=ts"
export * from "./Tichete.vue?vue&type=script&lang=ts"

import "./Tichete.vue?vue&type=style&index=0&id=7b293ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b293ad2"]])

export default __exports__